import { z } from 'zod';

export function isEmail(input: string): boolean {
  return z.string().email().safeParse(input).success;
}
